import { render, staticRenderFns } from "./ObjectivesView.vue?vue&type=template&id=f490e67e"
import script from "./ObjectivesView.vue?vue&type=script&lang=js"
export * from "./ObjectivesView.vue?vue&type=script&lang=js"
import style0 from "./ObjectivesView.vue?vue&type=style&index=0&id=f490e67e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports